import ChainGraph from '@/features/referral-shared/ChainGraph';

const fmt = (n) =>
    new Intl.NumberFormat('fa-IR', { maximumFractionDigits: 0 }).format(
        Number(n) || 0
    );

const fmtPercent = (n) =>
    `${new Intl.NumberFormat('fa-IR', { maximumFractionDigits: 4 }).format(
        Number(n) || 0
    )}٪`;

// === [ADDED] تبدیل اعداد به فارسی ===
const faNum = (n) => new Intl.NumberFormat('fa-IR').format(Number(n));
// ==================================

export default function ModelsComparison({ data }) {
    if (!data || !data.models || data.models.length === 0) return null;

    return (
        <div className="models-comparison">
            <div className="models-comparison-header">
                <h3>مقایسه مدل‌های توزیع</h3>
                <p>
                    مبلغ فروش: <strong>{fmt(data.sales_amount)} ریال</strong>
                    {' • '}
                    حاشیه سود: <strong>{fmtPercent(data.margin_percent)}</strong>
                    {' • '}
                    {/* === [CHANGED] استفاده از faNum برای عمق زنجیره === */}
                    عمق زنجیره: <strong>{faNum(data.max_depth)} سطح</strong>
                </p>
            </div>

            {/* === [CHANGED] حذف استایل‌های اینلاین که باعث کوچک شدن می‌شد === */}
            <div className="models-graphs">
                {data.models.map((model) => (
                    <ChainGraph
                        key={model.distribution}
                        model={model}
                        salesAmount={data.sales_amount}
                        marginPercent={data.margin_percent}
                        minMarginPercent={data.min_margin_percent}
                    />
                ))}
            </div>
        </div>
    );
}